// The state a game is in, the same few for everyone, whoever is looking (the game's header, the list of games): whose
// turn it is, and what holds the game up, if anything, without naming the cards involved (those are for the players in
// it to see):
//   state: 'political' | 'action' (the turn's phase), or what is being resolved: 'event', 'aggression' (the defender
//          deciding whether to defend), 'aggressionResolution' (what a won aggression does: the aggressor's choice, and
//          what follows), 'war' (its winner choosing), 'colonization', 'pact'; or 'over'
//   label: its name ("Political phase", "Aggression"...)
//   player / name: whose turn it is; waitingOn: the names of the players it waits on (decisions to make), turn order
const EventNames = require('../Constants/Names/EventNames');
const { ActiveBlocking } = require('../Moves/Decisions');

const Labels = {
    political: 'Political phase', action: 'Action phase', event: 'Event resolution', aggression: 'Aggression',
    aggressionResolution: 'Aggression resolution', war: 'War resolution', colonization: 'Colonization', pact: 'Pact offer', over: 'Game over',
};
const EventCards = new Set(Object.values(EventNames));

const GameStatus = (gameState) => {
    const current = gameState.GetCurrentPlayerState();
    const decisions = gameState.decisions ?? [];
    const state = gameState.finished ? 'over'
        : gameState.aggression ? (decisions.some(d => d.type === 'defend') ? 'aggression' : 'aggressionResolution')
        : gameState.auction ? 'colonization'
        : decisions.some(d => d.type === 'warChoice') ? 'war'
        : decisions.some(d => d.type === 'pactOffer') ? 'pact'
        : decisions.some(d => EventCards.has(d.event)) ? 'event'
        // (still political while the political action is being resolved)
        : gameState.politicalResolving || gameState.phase === 'Political' ? 'political' : 'action';
    // Who it waits on: the one deciding now (decisions that hold the game up go one at a time), else everyone with one
    const active = ActiveBlocking(gameState);
    const waiting = active ? [active.player] : [...new Set(decisions.map(d => d.player))];
    return {
        state,
        label: Labels[state],
        player: current.playerNumber,
        name: current.name,
        waitingOn: state === 'over' ? [] : waiting.map(number => gameState.playerStates[number].name),
    };
};

module.exports = { GameStatus, Labels };
